import { makeStyles } from '@material-ui/core/styles';

import { DOCUMENT_SCORE_PANEL_HEIGHT } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'center',
      minHeight: DOCUMENT_SCORE_PANEL_HEIGHT,

      '&$expanded': {
        '& $panel': {
          pointerEvents: 'all',
          zIndex: 1,
          opacity: 1,
          transform: `translateY(${theme.spacing(0)}px)`,
        },

        '& $score': {
          zIndex: 1,
          transform: `translateY(${theme.spacing(-1)}px)`,
        },
        right: theme.spacing(0.5),
      },

      '&:hover': {
        cursor: 'pointer',
      },

      '&$disabled': {
        '& $panel, &:hover': {
          cursor: 'default',
        },

        '& $link': {
          pointerEvents: 'none',
        },
      },

      transition: theme.transitions.create('top', {
        duration: theme.transitions.duration.shortest,
      }),
    },
    expanded: {},
    disabled: {},

    panel: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'flex-start',
      cursor: 'pointer',
      overflow: 'hidden',

      backgroundColor: '#FFFFFF',
      transform: `translateY(${theme.spacing(-1)}px)`,

      pointerEvents: 'none',
      opacity: 0,
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.short,
      }),
    },
    score: {
      transition: theme.transitions.create(['transform'], {
        duration: theme.transitions.duration.short,
      }),
      right: theme.spacing(0.5),
    },
    link: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
      textDecoration: 'none',
    },
    icon: {},
    arrow: {
      fontSize: theme.typography.pxToRem(16),
    },
  }),
  { name: 'DocumentScorePanel' }
);
